import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Cookies from "js-cookie";
import { useForm, Controller } from "react-hook-form";
import { countryCode, CountryList } from "../../apis/api/CountryList";
import { MemberUpdate } from "../../apis/api/MemberApi";
import { GetBranches } from "../../apis/api/ProfileApi";
import Lodderr from "../../components/Lodder/Lodder";
import { toast } from "react-toastify";
import { GetMembers } from "../../apis/api/MemberApi";
import cookies from "js-cookie";
import "./MemberModals.css";

const EditDetailsofMember = ({ show, onHide, data, company_id, userId }) => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
  const [branchOptions, setBranchOptions] = useState([]);
  const [branchLoading, setBranchLoading] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
 
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const countryCodeData = useSelector((state) => state.countrySlice);
  const countryCodeOptions = countryCodeData?.countryCode?.data?.data || [];
  const { loading } = useSelector((state) => state.MemberSlice);
  const { country } = useSelector((state) => state.countrySlice);

  const titleOptions = ["Mr", "Mrs", "Ms"].map((t) => ({ label: t, value: t }));

  const handleCloseModal = () => {
    reset();
    setSelectedBranch(null);
    setPreview(null);
    onHide();
  };

  useEffect(() => {
    dispatch(countryCode());
    dispatch(CountryList());
  }, [dispatch]);

  useEffect(() => {
    const effectiveCoId = company_id || cookies.get("company_id");
    if (effectiveCoId && show) {
      setBranchLoading(true);
      dispatch(GetBranches({ company_id: effectiveCoId }))
        .unwrap()
        .then((res) => {
          if (res?.data && Array.isArray(res.data)) {
            const approved = res.data.filter((b) => b.approve === 1);
            const options = approved.map((b) => ({
              value: b.id,
              label: `${b.city ? b.city + ' - ' : ''}${b.country || ''} (${b.main_branch === 1 ? 'Head Office' : 'Branch Office'})`,
              isHQ: b.main_branch === 1,
            }));
            setBranchOptions(options);

            const initialBranch = (data?.branch_id && options.find((o) => String(o.value) === String(data.branch_id))) ||
                                  options.find((o) => o.isHQ) || 
                                  options[0] || 
                                  null;
            if (initialBranch) {
              setSelectedBranch(initialBranch);
              setValue("Branch", initialBranch);
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          setBranchLoading(false);
        });
    }
  }, [dispatch, show, company_id, data, setValue]);

  useEffect(() => {
    if (data && country?.length && countryCodeOptions?.length) {
      const selectedCountry = country.find(
        (c) => c.label?.trim() === data?.country?.trim()
      );

      const selectedCode = countryCodeOptions.find(
        (code) =>
          code.label?.trim().endsWith(" " + data.country_code) ||
          code.value?.trim().endsWith(" " + data.country_code)
      );

      const resolvedBranch = selectedBranch || 
        (data?.branch_id && branchOptions.find((o) => String(o.value) === String(data.branch_id))) || 
        branchOptions.find((o) => o.isHQ) || 
        null;

      reset({
        Title: data.salutation
          ? { label: data.salutation, value: data.salutation }
          : null,
        FirstName: data.first_name || "",
        MemberId: data.id || "",
        MiddleName: data.middle_name || "",
        LastName: data.last_name || "",
        JobTitle: data.job_title || "",
        Department: data.department || "",
        PhoneDirect: data.contact || "",
        Email: data.email || "",
        Country: selectedCountry || null,
        CountryCode: selectedCode || null,
        Access: data.member_Access?.toString() || "0",
        Branch: resolvedBranch,
      });

      setPreview(
        typeof data.member_logo === "string"
          ? data.member_logo
          : data.member_logo instanceof File
          ? URL.createObjectURL(data.member_logo)
          : null
      );
    }
  }, [data, reset, country, countryCodeOptions, selectedBranch, branchOptions]);

  const onSubmit = async (formData) => {
    const form = new FormData();
    const mappedFields = {
      Title: formData.Title?.value || "",
      FirstName: formData.FirstName,
      MiddleName: formData.MiddleName,
      LastName: formData.LastName,
      JobTitle: formData.JobTitle,
      Department: formData.Department,
      PhoneDirect: formData.PhoneDirect,
      Email: formData.Email,
      Country: formData.Country?.label || "",
      CountryCode: formData.CountryCode?.value || "",
      Access: formData.Access,
      MemberId: formData.MemberId,
    };

    for (let key in mappedFields) {
      if (mappedFields[key] !== undefined && mappedFields[key] !== null) {
        form.append(key, mappedFields[key]);
      }
    }

    const branchVal = formData.Branch?.value || selectedBranch?.value || data?.branch_id;
    if (branchVal) {
      form.append("BranchId", branchVal);
      form.append("branch_id", branchVal);
    }

    if (formData.ProfilePicture instanceof File) {
      form.append("ProfilePicture", formData.ProfilePicture);
    }


    const response = await dispatch(MemberUpdate(form));
    const resPayload = response?.payload;
    if (resPayload?.status === "success") {
      await dispatch(GetMembers({ company_id, userId }));
      toast.success("Member updated successfully.");
    } else {
      const errorMsg =
        resPayload?.message ||
        resPayload?.data?.message ||
        response?.error?.message ||
        "Error in form submission.";
      toast.error(errorMsg);
    }
    handleCloseModal();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setValue("ProfilePicture", file, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <>
      {loading && <Lodderr />}
      <Modal
        show={show}
        onHide={handleCloseModal}
        size="lg"
        centered
        contentClassName="mm-modal"
      >
        <Modal.Header closeButton className="mm-head">
          <Modal.Title className="mm-title">
            <i className="bx bx-edit"></i> Update Member
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mm-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4">
              {/* Profile Picture */}
              <div className="col-md-12">
                <label className="mm-label">Profile Picture</label>
                <div
                  className="mm-upload"
                  onClick={() =>
                    document.getElementById("member-logo-upload").click()
                  }
                >
                  <input
                    type="file"
                    id="member-logo-upload"
                    accept="image/*"
                    className="d-none"
                    onChange={handleFileChange}
                  />
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      className="mm-avatar"
                    />
                  ) : (
                    <>
                      <i className="bx bx-cloud-upload mm-upload-ic"></i>
                      <span className="mm-upload-t">Click to upload</span>
                      <span className="mm-upload-s">PNG/JPG up to 5MB</span>
                    </>
                  )}
                </div>
              </div>

              {/* Title */}
              <div className="col-md-12">
                <label className="mm-label">Title</label>
                <Controller
                  name="Title"
                  control={control}
                  rules={{ required: "Title is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={titleOptions}
                      placeholder="Select Title"
                      classNamePrefix="mm-select"
                    />
                  )}
                />
                {errors.Title && (
                  <p className="mm-err">{errors.Title.message}</p>
                )}
              </div>

              {/* Name Fields */}
              {["FirstName", "MiddleName", "LastName"].map((field) => (
                <div className="col-md-4" key={field}>
                  <label className="mm-label">
                    {field.replace("Name", " Name")}
                  </label>
                  <input
                    type="text"
                    className="form-control mm-input"
                    placeholder={
                      field === "FirstName"
                        ? "John"
                        : field === "MiddleName"
                        ? "M."
                        : "Doe"
                    }
                    {...register(field, {
                      required:
                        field !== "MiddleName"
                          ? `${field.replace("Name", " name")} is required`
                          : false,
                    })}
                  />
                  {errors[field] && (
                    <p className="mm-err">{errors[field].message}</p>
                  )}
                </div>
              ))}

              {/* Job Title */}
              <div className="col-md-6">
                <label className="mm-label">Job Title</label>
                <input
                  type="text"
                  className="form-control mm-input"
                  placeholder="Enter job title"
                  {...register("JobTitle", {
                    required: "Job title is required",
                  })}
                />
                {errors.JobTitle && (
                  <p className="mm-err">{errors.JobTitle.message}</p>
                )}
              </div>

              {/* Department */}
              <div className="col-md-6">
                <label className="mm-label">Department</label>
                <input
                  type="text"
                  className="form-control mm-input"
                  placeholder="Enter department"
                  {...register("Department", {
                    required: "Department is required",
                  })}
                />
                {errors.Department && (
                  <p className="mm-err">{errors.Department.message}</p>
                )}
              </div>

              {/* Phone Number with Country Code */}
              <div className="col-md-12">
                <label className="mm-label">Phone Number</label>
                <div className="d-flex gap-2">
                  <Controller
                    name="CountryCode"
                    control={control}
                    rules={{ required: "Country code is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        className="w-25"
                        options={countryCodeOptions}
                        placeholder="Code"
                        classNamePrefix="mm-select"
                      />
                    )}
                  />
                  <input
                    type="text"
                    className="form-control w-75 mm-input"
                    {...register("PhoneDirect", {
                      required: "Phone number is required",
                    })}
                  />
                </div>
                {errors.CountryCode && (
                  <p className="mm-err">{errors.CountryCode.message}</p>
                )}
                {errors.PhoneDirect && (
                  <p className="mm-err">{errors.PhoneDirect.message}</p>
                )}
              </div>

              {/* Country Dropdown */}
              <div className="col-md-12">
                <label className="mm-label">Country</label>
                <Controller
                  name="Country"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={country}
                      placeholder="Select Country"
                      classNamePrefix="mm-select"
                    />
                  )}
                />
                {errors.Country && (
                  <p className="mm-err">{errors.Country.message}</p>
                )}
              </div>

              {/* Branch Dropdown */}
              <div className="col-md-12">
                <label className="mm-label">Branch / Office Location</label>
                <Controller
                  name="Branch"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      value={field.value || selectedBranch}
                      onChange={(val) => {
                        field.onChange(val);
                        setSelectedBranch(val);
                      }}
                      options={branchOptions}
                      placeholder={branchLoading ? "Loading branches..." : "Select Branch Office"}
                      isLoading={branchLoading}
                      isClearable={false}
                      classNamePrefix="mm-select"
                    />
                  )}
                />
              </div>

              {/* Access */}
              <div className="col-md-12">
                <label className="mm-label">Access</label>
                <Controller
                  name="Access"
                  control={control}
                  rules={{ required: "Access type is required" }}
                  render={({ field }) => (
                    <>
                      <label className={`mm-radio ${field.value === "0" ? "active" : ""}`}>
                        <input
                          className="form-check-input"
                          type="radio"
                          id="admin"
                          value="0"
                          checked={field.value === "0"}
                          onChange={field.onChange}
                        />
                        <span>Admin</span>
                      </label>
                      <label className={`mm-radio ${field.value === "1" ? "active" : ""}`}>
                        <input
                          className="form-check-input"
                          type="radio"
                          id="member"
                          value="1"
                          checked={field.value === "1"}
                          onChange={field.onChange}
                        />
                        <span>Member</span>
                      </label>
                    </>
                  )}
                />
                {errors.Access && (
                  <p className="mm-err">{errors.Access.message}</p>
                )}
              </div>

              <input type="text" name="MemberId" hidden />

              {/* Submit Button */}
              <div className="col-12">
                <div className="mm-actions">
                  <button type="button" className="mm-btn mm-btn--soft" onClick={handleCloseModal}>
                    Cancel
                  </button>
                  <button type="submit" className="mm-btn" disabled={loading}>
                    {loading ? "Updating..." : "Update Member"}
                    <i className="bx bx-right-arrow-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditDetailsofMember;
